<template>
  <div>
    <layout>
      <Search
        slot="header-bar"
        show-action
        placeholder="输入设备编号或点击扫码搜索"
        v-model="deviceSn"
        @search="onRefresh"
      >
        <div
          style="display: flex;width: 100%;justify-content: center;align-item: center"
          @click="qrScan"
          slot="action"
        >
          <van-icon size="20px" name="scan" />
        </div>
        <!--<div slot="left-icon">-->
        <!--<Select size="mini" :data="alarmLevelList" @ok="alarmLevelOk"/>-->
        <!--</div>-->
        <div slot="left-icon">
          <span @click="openSearchPanel">高级</span>
        </div>
        <!-- <div slot="action" @click="onRefresh">搜索</div> -->
      </Search>
      <PullRefresh v-model="isReFresh" @refresh="onRefresh">
        <List
          style="padding: 0px 12px"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          loading-text="拼命加载中..."
          @load="onLoad"
          :offset="50"
          :immediate-check="true"
        >
          <AlarmItem
            v-for="item in list"
            type="realTime"
            :key="item.id"
            :info="item"
          />
        </List>
      </PullRefresh>
    </layout>
    <Popup v-model="show" position="top">
      <Field
        v-model="search.unitName"
        label="所在单位"
        readonly
        clearable
        placeholder="请选择所在单位"
        right-icon="arrow-down"
        @click="unitPanel = true"
      />
      <Field
        clearable
        v-model="typeName"
        label="告警类型"
        placeholder="请选择告警类型"
        readonly
        right-icon="arrow-down"
        @click="selectShow = true"
        :rules="[{ required: true, message: '告警类型必选' }]"
      />
      <Field
        v-model="search.startTime"
        label="开始时间"
        readonly
        placeholder="请选择开始时间"
        right-icon="arrow-down"
        @click="showStartTimePanel(true)"
      />
      <Field
        v-model="search.endTime"
        label="结束时间"
        readonly
        placeholder="请选择结束时间"
        right-icon="arrow-down"
        @click="showEndTimePanel(true)"
      />
      <Button
        type="info"
        block
        style="width: 90% ; margin: 10px auto;"
        @click="onRefresh"
        >查询</Button
      >
    </Popup>
    <SelectTreePopup
      :show="unitPanel"
      :defaultSelected="
        search.unitId ? { id: search.unitId, name: search.unitName } : {}
      "
      :treeData="unitTree"
      :defaultTitle="search.unitName || '选择单位'"
      @ok="onUnitOk"
      @cancel="unitPanel = false"
    />
    <SelectDict
      :showAll="true"
      dictKey="EVENT_TYPE"
      :show="selectShow"
      @cancel="selectShow = false"
      @ok="onTypeOk"
    />
    <DateTimePopup
      type="start"
      :max="search.endTime"
      :time="search.startTime"
      :timePanel="startTimePanel"
      @cancel="showStartTimePanel(false)"
      @ok="changeStartTime"
    />
    <DateTimePopup
      type="end"
      :min="search.startTime"
      :time="search.endTime"
      :timePanel="endTimePanel"
      @cancel="showEndTimePanel(false)"
      @ok="changeEndTime"
    />
  </div>
</template>

<script>
import { Button, Field, List, Popup, PullRefresh, Search } from "vant";
import Select from "@/components/Select";
import wx from "weixin-js-sdk";
import AlarmItem from "./components/AlarmItem";
import SelectDict from "@/components/SelectPopup/SelectDict";
import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup";
import DateTimePopup from "./../../components/DateTimePopup";
import { mapGetters } from "vuex";
import { dateFormat } from "@/utils/tool";

export default {
  components: {
    Search,
    List,
    Select,
    PullRefresh,
    AlarmItem,
    SelectDict,
    Popup,
    Field,
    Button,
    SelectTreePopup,
    DateTimePopup,
  },
  props: {},
  data() {
    return {
      page: 1,
      list: [],
      deviceSn: null,
      loading: false,
      isReFresh: false,
      finished: false,
      show: false,
      unitName: null,
      startTimePanel: false,
      endTimePanel: false,
      selectShow: false,
      unitPanel: false,
      typeName: null,
      search: {
        unitId: null,
        unitName: null,
        startTime: "",
        endTime: "",
        eventType: null,
      },
    };
  },
  computed: {
    ...mapGetters({ unitTree: "global/unitTree" }),
  },
  created() {
    const { unitOrOrgan } = this.$default;
    this.search.unitName = unitOrOrgan.name;
    this.search.unitId = unitOrOrgan.id;
  },
  mounted() {
    // this.initDate()
  },
  methods: {
    onUnitOk(data) {
      this.unitPanel = false;
      this.search.unitId = data.id;
      this.search.unitName = data.name;
    },
    openSearchPanel() {
      this.show = true;
    },
    initDate() {
      const endTime = new Date();
      const startTime = new Date(endTime.getTime() - 1000 * 60 * 60 * 24 * 7);
      this.search.startTime = dateFormat("YYYY-MM-DD HH:mm:ss", startTime);
      this.search.endTime = dateFormat("YYYY-MM-DD HH:mm:ss", endTime);
    },
    showStartTimePanel(show) {
      this.startTimePanel = show;
    },
    changeStartTime(value) {
      this.search.startTime = value;
      this.startTimePanel = false;
    },
    showEndTimePanel(show) {
      this.endTimePanel = show;
    },
    changeEndTime(value) {
      this.search.endTime = value;
      this.endTimePanel = false;
    },
    onTypeOk(data) {
      this.typeName = data.codeName;
      if (data.code == "All") this.search.eventType = null;
      else this.search.eventType = data.code;

      this.selectShow = false;
    },
    qrScan() {
      const This = this;
      console.info("扫一扫啊");
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let index = res.resultStr.indexOf(`CODE_128,`);
          if (index === -1) {
            This.deviceSn = res.resultStr;
            this.onRefresh();
          } else {
            let len = res.resultStr.length;
            This.deviceSn = res.resultStr.slice(index + 9, len - 1);
            this.onRefresh();
          }
        },
      });
    },
    onLoad(isPullRefresh) {
      this.$http.tokiot.device.alarm
        .list({
          eventType: this.search.eventType,
          deviceSn: this.deviceSn,
          startTime: this.search.startTime,
          endTime: this.search.endTime,
          unitId: this.search.unitId,
          size: 20,
          page: this.page,
        })
        .then((ret) => {
          if (ret) {
            ret.rows.map((item) => (item.params = JSON.parse(item.params)));
            this.list.push(...ret.rows);
            this.page = ret.pageNumber + 1;
            this.loading = false;
            if (isPullRefresh) this.isReFresh = false;
            // 数据全部加载完成
            if (this.list.length >= ret.total) {
              this.finished = true;
            }
          }
        });
    },

    // 下拉刷新
    onRefresh() {
      const that = this;
      that.show = false;
      that.isReFresh = true;

      that.$http.tokiot.device.alarm
        .list({
          eventType: that.search.eventType,
          deviceSn: that.deviceSn,
          startTime: that.search.startTime,
          endTime: that.search.endTime,
          unitId: that.search.unitId,
          size: 20,
          page: 1,
        })
        .then((ret) => {
          if (ret) {
            that.isReFresh = false;
            that.list = [];
            ret.rows.map((item) => {
              item.params = JSON.parse(item.params);
            });
            that.page = ret.pageNumber + 1;
            this.list.push(...ret.rows);
          }
        });
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped></style>